module.exports = "/images/GC-Hero.jpg";